export const USER_INFO = "USER_INFO";
export const CURRENT_WEEKLY = "CURRENT_WEEKLY";
export const WEEKLY_LIST = "WEEKLY_LIST";
export const DEPARTMENT_WEEKLY_LIST = "DEPARTMENT_WEEKLY_LIST"



// WEBPACK FOOTER //
// ./src/vuex/mutation-types.js